import { Box, SectionHelper } from '@wix/design-system';
import { CycleUtils, useFormatDate, usePageScrollLock } from '@wix/package-picker-shared';
import { PremiumPurchasePlatformModule } from '@wix/premium-purchase-platform/@sdk';
import React from 'react';
import { PlanFeaturesModalContent } from '../../../../components';
import { SwitchProductModule } from '../../switch-product.module';
export const PlanFeaturesModal = _ref => {
  var _currentProduct$prici;
  let {
    onClose,
    onShow
  } = _ref;
  const {
    t,
    Trans
  } = SwitchProductModule.internals.useTranslations();
  const {
    locale
  } = SwitchProductModule.internals.useContext();
  const formatDate = useFormatDate({
    locale
  });
  usePageScrollLock();
  const platformContext = PremiumPurchasePlatformModule.internals.useContext();
  const {
    data: currentProductData
  } = SwitchProductModule.SDK.switchApiClient.hooks.useGetCurrentProduct({});
  const currentProduct = currentProductData == null ? void 0 : currentProductData.currentProduct;
  const cycleKey = `change_plan.current_plan_modal.${CycleUtils.convertToBillingPaymentCycle(currentProduct == null ? void 0 : currentProduct.cycle)}.billed`;
  const monthlyPrice = currentProduct == null || (_currentProduct$prici = currentProduct.pricing) == null || (_currentProduct$prici = _currentProduct$prici.monthlyTotal) == null ? void 0 : _currentProduct$prici.formattedAmount;
  const subtitleKey = monthlyPrice ? 'change_plan.current_plan_modal.payment_details_advanced' : 'change_plan.current_plan_modal.payment_details_advanced.new';
  const subtitle = t(subtitleKey, {
    planName: currentProduct == null ? void 0 : currentProduct.productName,
    price: monthlyPrice,
    cycle: t(cycleKey),
    endDate: formatDate((currentProduct == null ? void 0 : currentProduct.periodEndDate) ?? undefined)
  });
  const shouldShowSectionHelper = !(currentProductData != null && currentProductData.isCurrentProductFamilyInOffering) && !(currentProductData != null && currentProductData.isCurrentProductInOffering);
  const sectionHelper = shouldShowSectionHelper ? /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(SectionHelper, {
    skin: "standard"
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "change_plan.current_plan_modal.explanation_advanced",
    values: {
      planName: currentProduct == null ? void 0 : currentProduct.productName
    },
    components: [/*#__PURE__*/React.createElement("strong", null)]
  }))) : undefined;
  const handleClose = () => {
    onClose == null || onClose();
    SwitchProductModule.SDK.modalsController.PlanFeaturesModal.hide();
  };
  React.useEffect(() => {
    onShow == null || onShow();
  }, [onShow]);
  return /*#__PURE__*/React.createElement(PremiumPurchasePlatformModule.Provider, {
    translations: {
      Loading: /*#__PURE__*/React.createElement(React.Fragment, null)
    },
    context: {
      productTypeId: platformContext.productTypeId,
      purchaseContext: {}
    }
  }, /*#__PURE__*/React.createElement(PlanFeaturesModalContent, {
    productId: (currentProduct == null ? void 0 : currentProduct.productId) ?? '',
    title: t('Advanced.Plans_change.plan_modal.view_current_plan_title'),
    t: t,
    Trans: Trans,
    subtitle: subtitle,
    footer: sectionHelper,
    maxHeight: "calc(100vh - 2 * var(--wds-space-800))",
    onClose: handleClose
  }));
};
//# sourceMappingURL=PlanFeaturesModal.js.map